import { createSlice } from "@reduxjs/toolkit";

import {
  addPickListThunk,
  deletePickListThunk,
  fetchPickListThunk,
  updatePickListThunk,
} from "../thunks/pickListThunk";

import type { PickList } from "../../utils/types/pickList";

interface PickListState {
  pickList: PickList[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: PickListState = {
  pickList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const pickListSlice = createSlice({
  name: "pickList",
  initialState,
  reducers: {
    resetPickListDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPickListThunk.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
        state.error = null;
      })
      .addCase(fetchPickListThunk.fulfilled, (state, action) => {
        state.pickList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchPickListThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(updatePickListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePickListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.pickList = state.pickList.map((item: PickList) => {
          if (item?.id === action?.payload?.data?.id) {
            return { ...item, ...action?.payload?.data };
          }
          return item;
        });
      })
      .addCase(updatePickListThunk.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deletePickListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePickListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.pickList = state.pickList.filter(
          (item) => item.id !== action?.payload?.id
        );
      })
      .addCase(deletePickListThunk.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addPickListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPickListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.pickList = [action.payload, ...state.pickList];
      })
      .addCase(addPickListThunk.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
  },
});

export const { resetPickListDataFetched } = pickListSlice.actions;

export default pickListSlice.reducer;
